import { AsyncPipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { Component, inject, AfterViewInit, ViewChild } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';


import { MatSidenavModule } from '@angular/material/sidenav';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

import { FieldTemplate, FormTemplate } from '../../models/form';

import { FormService } from '../../services/form-service';
import { ActivatedRoute } from '@angular/router';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Subject, Observable, map, shareReplay, takeUntil } from 'rxjs';
import { User } from '../../models/user';
import { UserService } from '../../services/user-service';


@Component( {
  selector: 'app-form-editor-component',
  imports: [
    AsyncPipe,
    RouterLink,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSidenavModule,
    MatInputModule,
    MatPaginatorModule,
    MatTableModule,
    MatSlideToggleModule,
    MatListModule,
    MatIconModule,
    MatButtonModule,
  ],
  templateUrl: './form-editor-component.html',
  styleUrl: './form-editor-component.css'
} )
export class FormEditorComponent implements AfterViewInit
{
  private breakpointObserver = inject( BreakpointObserver );
  private destroy$ = new Subject<void>();

  isHandset$: Observable<boolean> = this.breakpointObserver.observe( Breakpoints.Handset )
    .pipe(
      map( result => result.matches ),
      shareReplay( { refCount: true, bufferSize: 1 } ),
      takeUntil( this.destroy$ )
    );

  constructor( public _formService: FormService, private _user: UserService )
  { }

  private route: ActivatedRoute = inject( ActivatedRoute );
  private user: User | null = null;

  public pct = this.route.snapshot.paramMap.get( 'pct' ) || 'C';
  public formId = Number( this.route.snapshot.paramMap.get( 'formId' ) ) || 111;
  public hubId: string | null = null
  public agencyId: number | null = null
  public formGroup: FormGroup | null = null;
  public formDefinition: FormTemplate | undefined;
  protected dataSource = new MatTableDataSource<FieldTemplate>( [] );
  protected displayedColumns: string[] =
    [
      'formOrder', 'columnName', 'labelText', 'labelTextEs', 'fieldType', 'defaultValue',
      'isRequired', 'validationRegex','validationRegexErrorMsg'
    ];
  protected length = 0;
  protected pageSize = 10;
  protected pageIndex = 0;
  protected pageSizeOptions = [10, 20, 50, 100];

  async ngOnInit(): Promise<void>
  {
    // Initialization logic can go here if needed
    this.user = this._user.getUser();
    this.hubId = this.route.snapshot.paramMap.get( 'hubId' ) || this.user?.hubId || '221';
    this.agencyId = Number( this.route.snapshot.paramMap.get( 'agencyId' ) ) || Number( this.user?.workingAreaId ) || null;
    console.log( 'FormEditorComponent initialized with:', { hubId: this.hubId, agencyId: this.agencyId } );
    this.formDefinition = await this._formService.getFormDefinition( this.pct, this.formId, this.hubId, this.agencyId )
    if ( this.formDefinition )
    {
      this.formGroup = this._formService.generateDynamicFormTemplate( this.formDefinition.fields );
      this.dataSource.data = this.formDefinition.fields;
      this.length = this.dataSource.data.length;
    } else
    {
      console.error( 'Form definition not found.' );
    }
  }

  save(): void
  {
    console.log( 'Saving form definition...' );
  }

  ngOnDestroy(): void
  {
    this.destroy$.next();
    this.destroy$.complete();
    console.log( 'FormEditorComponent destroyed.' );  
  }

  @ViewChild( MatPaginator ) paginator!: MatPaginator;


  ngAfterViewInit()
  {
    this.dataSource.paginator = this.paginator;
  }


}


